import React from 'react';

import { CustomMarker } from "react-instantsearch-dom-maps";

const CompanySearchMapMarker = ({ hit, onClick, active}) => (
    <CustomMarker hit={hit} key={hit.id}>
        <button className="ais-GeoSearch-marker" onClick={() => { onClick(hit); }} aria-selected={active ? 'true' : 'false'}>
            <svg viewBox="0 0 24 24">
                <use xlinkHref="#icon-location" />
            </svg>
        </button>
    </CustomMarker>
);

export { CompanySearchMapMarker };
